module.exports = __webpack_public_path__ + "052ec527b4bb18cd4e482c2c6a6ad4f6.svg";